import React from "react";

export function SoccerBallIcon({ size = 24, color = "currentColor", strokeWidth = 2, ...props }) {
  return <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    stroke={color}
    strokeWidth={strokeWidth}
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden={props["aria-label"] ? undefined : "true"}
    data-icon="soccer-ball"
    {...props}
  >
    <g fill={color} stroke="none" aria-hidden="true">
      <path d="M8.45 4.15A8.95 8.95 0 0 1 15.35 4l-1.45 1.75h-3.95L8.45 4.15Z" />
      <path d="M18.05 5.95a9 9 0 0 1 2.82 5.55l-2.3-.55-1.35-3.2.83-1.8Z" />
      <path d="M20.25 15.25a9 9 0 0 1-5.45 5.2l-.72-2.25 2.7-2.25 3.47-.7Z" />
      <path d="M11.15 20.95a9 9 0 0 1-6.35-3.6l1.78-1.55 3.18 1.62 1.39 3.53Z" />
      <path d="M3.08 13.2A9 9 0 0 1 5.2 6.4l1.88 1.25-.57 3.55-3.43 2Z" />
    </g>
    <path
      d="m12 6.75 3.7 2.7-1.42 4.35H9.72L8.3 9.45 12 6.75Z"
      fill={color}
      stroke="none"
      data-soccer-panel="center"
    />
    <g strokeWidth={Math.max(1.25, strokeWidth * 0.76)} data-soccer-panels="classic">
      <path d="M12 6.75 11.92 5.75M15.7 9.45l1.52-1.7M14.28 13.8l2.5 2.15M9.72 13.8l.04 3.62M8.3 9.45 6.51 11.2" />
    </g>
    <circle cx="12" cy="12" r="9" />
  </svg>;
}
